export default __webpack_public_path__ + "6b410917bf36a6e8c3d05e126a009b5b.png";